// Pick a stable, distinct color per activity type for UI chips (e.g. the
// ActivityFilterPanel). The live map preview intentionally does NOT use this
// — it renders every polyline with the single common color set in
// `settings.activities.color`, so the preview stays calm and the per-type
// settings only surface in the generated image.

const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getActivityTypeColor = (type, activitySettings) => {
  // In heatmap mode all activities are blended into one frequency
  // surface — per-type colors carry no meaning. Fall back to the
  // common color so the activity panel / chips / search popups stay
  // visually consistent with what's actually rendered.
  if (activitySettings?.mode === 'heatmap') {
    return activitySettings?.color || '#e11d48';
  }
  // When per-type coloring is OFF, every activity renders with the
  // common color — chips and dots must follow so the UI doesn't lie
  // about what the print will look like.
  if (!activitySettings?.byTypeEnabled) {
    return activitySettings?.color || '#e11d48';
  }
  // byType ON: use the explicit per-type override if set, else the
  // common color (matches the backend's `override.get("color") or
  // common_color` in location_map.py). Earlier we returned a
  // hash-derived hue here, which made UI chips disagree with the
  // actual rendered polyline color.
  const explicit = activitySettings?.byType?.[type]?.color;
  if (explicit) return explicit;
  return activitySettings?.color || '#e11d48';
};
